__turbopack_context__.v({
  "controls": "j6lDXq_controls",
  "info": "j6lDXq_info",
  "meta": "j6lDXq_meta",
  "price": "j6lDXq_price",
  "reason": "j6lDXq_reason",
  "row": "j6lDXq_row",
  "title": "j6lDXq_title",
  "titleLine": "j6lDXq_titleLine",
});
